<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <!-- Header with Back Button -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Order Details
        </h4>
        <button class="btn btn-secondary" (click)="goBack()">
          <i class="fa fa-arrow-left"></i> Back to Orders
        </button>
      </div>

      <div *ngIf="!loading && orderDetails._id">
        <div class="row mb-4">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Order Information</h5>
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Order Number:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{ orderDetails.orderNumber }}
                    </p>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Status:</label>
                  <div class="col-sm-7">
                    <span class="badge" style="
                        border-radius: 20px;
                        padding-left: 10px;
                        padding-right: 10px;
                        font-size: 13px;
                      " [ngClass]="getStatusBadgeClass()">
                      {{ getStatusDisplayText() }}
                    </span>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Total Amount:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext text-danger font-bold">
                      {{ orderDetails.currency }}
                      {{
                      orderDetails.chargeableAmount / 100 | number : "1.2-2"
                      }}
                    </p>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Delivery Type:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{
                      orderDetails.storeDeliveryServiceId
                      ? "Shipping":
                      orderDetails.deliveryType === "delivery"
                      ? "Home Delivery"
                      : (orderDetails.deliveryType | titlecase)
                      }}
                    </p>
                  </div>
                </div>

                <div class="form-group row" *ngIf="orderDetails.storeDeliveryServiceId">
                  <label class="col-sm-5 font-weight-bold">Delivery Service:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      <b>{{ orderDetails.storeDeliveryServiceId?.serviceName }}</b>
                    </p>
                  </div>
                </div>

                <!-- Tracking ID -->
                <div class="form-group row" *ngIf="orderDetails.storeDeliveryServiceId">
                  <label class="col-sm-5 font-weight-bold">Tracking ID:</label>
                  <div class="col-sm-7">

                    <!-- Show tracking ID -->
                    <p class="form-control-plaintext"
                      *ngIf="orderDetails.deliveryServiceTrackingId && !showTrackingInput">
                      <b>{{ orderDetails.deliveryServiceTrackingId }}</b>

                      <!-- Edit button -->
                      <button *ngIf="orderDetails.status === 'accepted'" class="btn btn-sm btn-link ml-2"
                        (click)="editTrackingId()">
                        Edit
                      </button>
                    </p>

                    <!-- Add Tracking ID Button -->
                    <button
                      *ngIf="!orderDetails.deliveryServiceTrackingId && orderDetails.status === 'accepted' && !showTrackingInput"
                      class="btn btn-sm btn-primary" (click)="showTrackingInput = true">
                      Add Tracking ID
                    </button>

                    <!-- Input + Save -->
                    <div *ngIf="showTrackingInput">
                      <input type="text" class="form-control mb-2" placeholder="Enter tracking ID"
                        [(ngModel)]="trackingId" />

                      <button class="btn btn-sm btn-success mr-2" (click)="addTrackingId(orderDetails._id)">
                        Save
                      </button>

                      <button class="btn btn-sm btn-secondary" (click)="cancelTrackingId()">
                        Cancel
                      </button>
                    </div>

                  </div>
                </div>


                <div class="form-group row" *ngIf="orderDetails.deliveryType === 'delivery'">
                  <label class="col-sm-5 font-weight-bold">Delivery Charge:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{ orderDetails.currency }}
                      {{ orderDetails.deliveryPrice | number : "1.2-2" }}
                    </p>
                  </div>
                </div>

                <div class="form-group row" *ngIf="orderDetails.distance">
                  <label class="col-sm-5 font-weight-bold">Distance:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{ orderDetails.distance | number : "1.1-1" }} km
                    </p>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Payment Method:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{ orderDetails.paymentMethodType || "N/A" }}
                    </p>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-5 font-weight-bold">Date:</label>
                  <div class="col-sm-7">
                    <p class="form-control-plaintext">
                      {{ orderDetails.created_at | date : "medium" }}
                    </p>
                  </div>
                </div>

                <div *ngIf="orderDetails?.storeLocationId as location">
                  <div class="form-group row">
                    <label class="col-sm-5 font-weight-bold">Address:</label>
                    <div class="col-sm-7">
                      <p class="form-control-plaintext">
                        {{
                        location.address ||
                        location.store_id?.storeAddress ||
                        "-"
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-5 font-weight-bold">Phone Number:</label>
                    <div class="col-sm-7">
                      <p class="form-control-plaintext">
                        {{ location.mobile || "-" }}
                      </p>
                    </div>
                  </div>

                  <div class="form-group row">
                    <label class="col-sm-5 font-weight-bold">Store Name:</label>
                    <div class="col-sm-7">
                      <p class="form-control-plaintext">
                        {{
                        location.name || location.store_id?.storeName || "-"
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div *ngIf="orderDetails?.donationId as donation">
                  <div class="form-group row">
                    <label class="col-sm-5 font-weight-bold">Charity Name:</label>
                    <div class="col-sm-7">
                      <p class="form-control-plaintext">
                        {{
                        donation.charityName ||
                        "-"
                        }}
                      </p>
                    </div>
                  </div>
                </div>

                <div *ngIf="orderDetails?.donationTransactionId as donationTransaction">
                  <div class="form-group row">
                    <label class="col-sm-5 font-weight-bold">Charity Amount:</label>
                    <div class="col-sm-7">
                      <p class="form-control-plaintext">
                        {{
                        donationTransaction.amount ||
                        "-"
                        }} ( {{donationTransaction.donationPercentage}}% )
                      </p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Customer Information</h5>
              </div>
              <div class="card-body">
                <div class="form-group row" *ngIf="orderDetails.user_id">
                  <label class="col-sm-4 font-weight-bold">Username:</label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext">
                      {{ orderDetails.user_id.username }}
                    </p>
                  </div>
                </div>

                <div class="form-group row" *ngIf="orderDetails.user_id">
                  <label class="col-sm-4 font-weight-bold">Email:</label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext">
                      {{ orderDetails.user_id.email }}
                    </p>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-sm-4 font-weight-bold">Phone number :</label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext">
                      {{ orderDetails.user_id.dialling_code }}
                      {{ orderDetails.user_id.mobile }}
                    </p>
                  </div>
                </div>

                <div class="form-group row" *ngIf="orderDetails.deliveryType === 'delivery'">
                  <label class="col-sm-4 font-weight-bold">Address:</label>
                  <div class="col-sm-8">
                    <p class="form-control-plaintext">
                      {{ orderDetails.userAddress }}
                    </p>
                  </div>
                </div>

                <div class="card mt-4" *ngIf="orderDetails.deliveryType === 'delivery'">
                  <div class="card-header">
                    <h5 class="mb-0">User Location</h5>
                  </div>
                  <div class="pt-4">
                    <div id="userMap"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Ordered Products</h5>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped align-middle text-sm">
                    <thead class="table-dark text-center">
                      <tr>
                        <th>Package Name</th>
                        <th>Package Image</th>
                        <th>Quantity</th>
                        <th>Barcode Image</th>
                        <th>Barcode ID</th>
                        <th>Unit Price</th>
                        <th>Membership <br />Discount</th>
                        <th>Coupon code<br /><small>(Discount)</small></th>
                        <th>Amount<br /><small>(Without VAT)</small></th>
                        <th>VAT %</th>
                        <th>VAT Amount</th>
                        <th>Total Amount</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let package of orderDetails.vendingPackagesItems" [style.text-decoration]="
    orderDetails.status === 'refunded' ? 'line-through' : 'none'
  " [style.text-decoration-color]="
    orderDetails.status === 'refunded' ? 'red' : ''
  ">
                        <td class="text-break">
                          {{ package?.packageId?.name }}
                        </td>

                        <td class="text-center">
                          <img [src]="package.packageId.productImage" [alt]="package?.packageId?.name" style="
                              height: 80px;
                              width: 120px;
                              border-radius: 10px;
                              object-fit: cover;
                            " class="img-thumbnail" onerror="this.src='assets/images/placeholder.jpg'" />
                        </td>

                        <td class="text-center">{{ package.quantity }}</td>

                        <td class="text-center">
                          <div class="img-preview-wrapper" *ngIf="package?.packageId?.barcodeImage; else noImage">
                            <img [src]="package.packageId.barcodeImage" [alt]="package?.packageId?.name"
                              class="img-thumbnail preview-thumb"
                              onerror="this.onerror=null; this.src='assets/images/placeholder.jpg';" />

                            <div class="img-preview-box">
                              <img [src]="package.packageId.barcodeImage"
                                onerror="this.onerror=null; this.src='assets/images/placeholder.jpg';" />
                            </div>
                          </div>

                          <ng-template #noImage>
                            <span>No Image</span>
                          </ng-template>
                        </td>

                        <td class="text-center">
                          <span class="badge badge-secondary">
                            {{ package?.packageId?.EANNumber || "N/A" }}
                          </span>
                        </td>


                        <td class="text-end">
                          {{ orderDetails.currency }}
                          {{ package?.packageId?.price | number : "1.2-2" }}
                        </td>

                        <td class="text-center">
                          <span [ngClass]="{
                              'text-success':
                                getItemLabel(package).includes('Free'),
                              'text-muted': getItemLabel(package) === 'N/A'
                            }">
                            {{ getItemLabel(package) }}
                          </span>
                        </td>

                        <td class="text-center">
                          <ng-container *ngIf="orderDetails.coupon_code_id; else noDiscount">
                            {{ orderDetails?.coupon_code_id?.discountPercent }}%
                            <br />
                            <small class="text-success">
                              -{{ orderDetails.currency }}
                              {{
                              getDiscountCouponAmount(
                              orderDetails?.coupon_code_id?.discountPercent,
                              package.totalMembershipDiscount
                              )
                              }}
                            </small>
                          </ng-container>
                          <ng-template #noDiscount>
                            <span class="text-muted">N/A</span>
                          </ng-template>
                        </td>

                        <td class="text-end">
                          {{ orderDetails.currency }}
                          {{ package.totalAmountWithoutVat | number : "1.2-2" }}
                        </td>

                        <td class="text-center">
                          {{ package.totalVatPercentage }}%
                        </td>

                        <td class="text-end">
                          {{ orderDetails.currency }}
                          {{ package.totalVatAmount | number : "1.2-2" }}
                        </td>

                        <td class="text-end fw-bold text-danger font-bold">
                          {{ orderDetails.currency }}
                          {{ package.chargeableAmount | number : "1.2-2" }}
                        </td>
                      </tr>

                      <tr *ngIf="
                          !orderDetails.vendingPackagesItems ||
                          orderDetails.vendingPackagesItems.length === 0
                        ">
                        <td colspan="10" class="text-center">
                          No products found
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row p-4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">Order Summary</h5>
              </div>
              <div class="card-body">
                <div class="d-flex justify-content-between">
                  <span>Subtotal (Without VAT):</span>
                  <span>{{ orderDetails.currency }}
                    {{
                    orderDetails.totalAmountWithoutVat | number : "1.2-2"
                    }}</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span>VAT ({{ orderDetails.totalVatPercentage }}%):</span>
                  <span>{{ orderDetails.currency }}
                    {{ orderDetails.totalVatAmount | number : "1.2-2" }}</span>
                </div>
                <div class="d-flex justify-content-between" *ngIf="orderDetails.deliveryType === 'delivery'">
                  <span>Delivery Charge:</span>
                  <span>{{ orderDetails.currency }}
                    {{ orderDetails.deliveryPrice | number : "1.2-2" }}</span>
                </div>
                <div class="d-flex justify-content-between" *ngIf="orderDetails.status === 'refunded'">
                  <span>Partially Refund Amount:</span>
                  <span>{{ orderDetails.currency }}
                    {{ orderDetails.refundAmount | number : "1.2-2" }}</span>
                </div>
                <hr />
                <div class="d-flex justify-content-between fw-bold text-danger">
                  <span>Total Amount:</span>
                  <span class="text-danger" style="font-weight: bold">{{ orderDetails.currency }}
                    {{
                    orderDetails.chargeableAmount / 100 | number : "1.2-2"
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div class="card">
              <div class="card-body btnGroupTitle">
                <div class="btn-group" role="group">
                  <button *ngIf="orderDetails.deliveryType === 'delivery' || orderDetails.deliveryType === 'pickup'"
                    class="btn btn-secondary m-2" (click)="PrintAddress(orderDetails)">
                    Print Details
                  </button>
                  <button *ngIf="orderDetails?.status !== 'refunded' && orderDetails?.status !== 'cancelled'"
                    class="btn btn-warning m-2" (click)="openPartialRefundModal(partialRefundModal)">
                    Partially Refund
                  </button>
                  <button *ngIf="getAvailableActions().includes('accept')" class="btn btn-success m-2"
                    (click)="acceptOrder()">
                    <i class="fa fa-check"></i> Accept Order
                  </button>
                  <button *ngIf="getAvailableActions().includes('outForDelivery')" class="btn btn-info m-2"
                    (click)="outForDelivery()">
                    <i class="fa fa-truck"></i> Mark Out for Delivery
                  </button>
                  <button *ngIf="getAvailableActions().includes('readyForPickUp')" class="btn btn-primary m-2"
                    (click)="readyForPickup()">
                    <i class="fa fa-hand-o-up"></i> Ready to Pickup
                  </button>
                  <button *ngIf="getAvailableActions().includes('complete')" class="btn btn-primary m-2"
                    (click)="completeOrder()">
                    <i class="fa fa-check-circle"></i> Complete Order
                  </button>
                  <button *ngIf="getAvailableActions().includes('cancel')" class="btn btn-danger m-2"
                    (click)="cancelOrder()">
                    <i class="fa fa-times"></i> Cancel Order
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!loading && !orderDetails._id" class="text-center py-4">
        <h5>Order not found</h5>
        <p>The requested order could not be found.</p>
      </div>
    </div>
  </div>
</div>

<ng-template #partialRefundModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Partially Refund</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group mb-4">
      <label class="font-weight-bold d-block mb-2">Ordered Products</label>
      <div class="table-responsive">
        <div class="table-wrapper">
          <table class="table table-bordered table-striped align-middle mb-0">
            <thead class="table-dark text-center sticky-header">
              <tr>
                <th>Select</th>
                <th>Package Name</th>
                <th>Package Image</th>
                <th>Quantity</th>
                <th>Barcode ID</th>
                <th>Total Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of orderDetails?.vendingPackagesItems">
                <td class="text-center">
                  <input type="checkbox" [checked]="isRefundItemSelected(item)"
                    (change)="onRefundItemToggle(item, $event)" />
                </td>

                <td>{{ item?.packageId?.name || "-" }}</td>

                <td class="text-center">
                  <img [src]="item?.packageId?.productImage" [alt]="item?.packageId?.name" class="img-thumbnail"
                    style="height: 70px; width: 100px; object-fit: cover"
                    onerror="this.src='assets/images/placeholder.jpg'" />
                </td>

                <td class="text-center">
                  {{ item?.quantity || 0 }}
                </td>

                <td class="text-center">
                  <span class="badge badge-secondary">
                    {{ item?.packageId?.EANNumber || "N/A" }}
                  </span>
                </td>

                <td class="text-end fw-bold">
                  {{ orderDetails?.currency }}
                  {{ item?.chargeableAmount | number : "1.2-2" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label for="refundAmount" class="font-weight-bold">
        Refund Amount
      </label>

      <input id="refundAmount" type="number" class="form-control" name="refundAmount" [(ngModel)]="refundAmount"
        #refundCtrl="ngModel" min="0" [max]="orderDetails.chargeableAmount / 100" step="0.01"
        placeholder="Enter refund amount" />

      <div class="text-danger mt-1" *ngIf="refundAmount < 0">
        Refund amount cannot be less than 0
      </div>

      <div class="text-danger mt-1" *ngIf="refundAmount > (orderDetails.chargeableAmount / 100)">
        Refund amount cannot be greater than
        {{ orderDetails.chargeableAmount / 100 }}
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      Cancel
    </button>
    <button type="button" class="btn btn-warning" [disabled]="
    isRefundSubmitting ||
    !selectedRefundItemIds.length ||
    !refundAmount ||
    refundAmount <= 0 ||
    refundAmount > (orderDetails.chargeableAmount / 100)
  " (click)="submitPartialRefund()">
      {{ isRefundSubmitting ? "Saving..." : "Save" }}
    </button>
  </div>
</ng-template>